// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Întreabă Amigo',
    assistant: 'Asistent',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Întreabă Amigo, noi: {{count}}',
    amigo_few: 'Întreabă Amigo, {{count}} noi',
    amigo_other: 'Întreabă Amigo, noi: {{count}}',
    assistant_one: 'Asistent, noi: {{count}}',
    assistant_few: 'Asistent, {{count}} noi',
    assistant_other: 'Asistent, noi: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo indisponibil',
    assistant: 'Asistent indisponibil',
  },
  unavailable_text: {
    amigo: 'Amigo nu este disponibil momentan.',
    assistant: 'Asistentul nu este disponibil momentan.',
  },
};
